/** sets up the skyscrapers on the left and right on homepage, enable after function */
function hp_floating_skyscrapers(){

	//Homepage - Floating SkyScraper Ads...
    var winWidth = $(window).width();

    var adMarkup = '<ul><li class="RC-AD RC-AD-SKY-TOP"></li><li class="RC-AD RC-AD-SKY-BOTTOM"></li></ul>';
    var adMarkUpAbsolute = '<li class="top-left RC-AD RC-AD-SKY-TOP"></li><li class="top-right RC-AD RC-AD-SKY-BOTTOM"></li>';

    if( winWidth >= 1520 ){
        //console.log("SCREEN WIDTH: You Meet Scrn Wid. Show Ads on Sides....");
        //console.log("Soups On.... Pre-Appending SkyScrapers to Container....");
        $("#container").prepend(adMarkUpAbsolute);
    }else{
        //console.log("SCRN WID: No Soup For You.... Going Hulk...");
        $(".gamma").append(adMarkup);
    }

    //var top_sky_pos = $("#most-read-box").position();
    //var top_sky_left = (top_sky_pos.left+45)+"px";
    var top = $('#container').offset().top;
    var offset_left = ($("#container").offset().left) + 'px';
    var offset_full = ($("#container").offset().left + 1360) + 'px';

    $(window).on('resize', function(){
        //console.log('RESIZING THE SOUP BOWL');

        winWidth = $(window).width();
        top = $('#container').offset().top;
        offset_left = ($("#container").offset().left) + 'px';
        offset_full = ($("#container").offset().left + 1360) + 'px';
        $(window).scroll();

    }).resize();

    if( winWidth >= 1520 ){
        $(window).scroll(function (event) {
            var y = $(this).scrollTop();
            if (y > top) {

                $(".top-left, .top-right").css({
                    "position" : "fixed"
                });

                $(".top-left").css({
                    "left" : offset_left
                });

                $(".top-right").css({
                    "left" : offset_full
                });

            }else { 
                $(".top-left, .top-right").css({
                    "position" : "absolute",
                    "top" : "5px"
                }); 

                $(".top-left").css({
                    "left" : 0
                });

                $(".top-right").css({
                    "left" : "1360px"
                });

            }
        }); //end window .scroll
    }
}

export default hp_floating_skyscrapers;